export function plainText(html) {
  if (!html) {
    return ''
  }
  return String(html).replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim()
}

export function summaryText(text, maxLength) {
  const value = plainText(text)
  if (!maxLength || value.length <= maxLength) {
    return value
  }
  return `${value.slice(0, maxLength)}...`
}

export function formatYear(dateText) {
  if (!dateText) {
    return ''
  }
  return String(dateText).slice(0, 4)
}

export function formatMonthDay(dateText) {
  if (!dateText) {
    return ''
  }
  const text = String(dateText)
  if (text.length >= 10) {
    return text.slice(5, 10)
  }
  return text
}

export function formatNewsMonth(dateText) {
  const year = formatYear(dateText)
  const monthDay = formatMonthDay(dateText)
  if (!year || !monthDay) {
    return ''
  }
  return `${year}.${monthDay.slice(0, 2)}`
}

export function formatDay(dateText) {
  const monthDay = formatMonthDay(dateText)
  return monthDay ? monthDay.slice(-2) : ''
}
